import { createReducer } from "redux-act";
import createAction from "../utils/createMetaAction";
import upsertDeleteActionGenerator from "./upsertDeleteActionGenerator";
export const upsertFeature = createAction("UPSERT_FEATURE");
export const deleteFeature = createAction("DELETE_FEATURE");
export default createReducer(
  {
    ...upsertDeleteActionGenerator(upsertFeature, deleteFeature)
  },
  {}
);
